import { EcardLandingRightPane } from './EcardLandingRightPane';
export default EcardLandingRightPane;
